type Props = {
    name: string,
    value: string,
}
const HeadInfo = (props: Props) => {
    const {name, value} = props;
    if(value===undefined||value===null||value.toString().length===0){
        return null;
    }
    return <div className="flex head-info justify-between items-center">
        <strong>{name}</strong>
        <span>{value}</span>
    </div>
}
export default HeadInfo;